import React from 'react';
import { Label } from '@components/ui/label';
import {
    RadioGroup as UiRadioGroup,
    RadioGroupItem
} from '@components/ui/radio-group';
import { FieldError, FieldLabel } from '../textfield';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface Option<T = any> {
    label: string;
    value: T;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface RadioGroupProps<T = any> {
    label: string;
    options: readonly Option<T>[];
    required?: boolean;
    disabled?: boolean;
    value?: T;
    error?: string;
    dataTestId?: string;
    onChange(value: T): void;
    row?: boolean;
}

export const RadioGroup = <T,>({
    required,
    disabled,
    error,
    label,
    options,
    value,
    dataTestId,
    onChange,
    row = true
}: RadioGroupProps<T>) => {
    const id = React.useId();
    return (
        <div className="flex flex-col gap-2" data-testid={dataTestId}>
            <FieldLabel label={label} required={required} />
            <UiRadioGroup
                value={String(value)}
                disabled={disabled}
                className={row ? 'flex flex-wrap gap-4' : 'flex flex-col gap-2'}
                onValueChange={(next) => {
                    const option = options.find(
                        (opt) => String(opt.value) === next
                    );
                    if (option) {
                        onChange(option.value);
                    }
                }}
            >
                {options.map((option) => (
                    <div
                        key={String(option.value)}
                        className="flex items-center gap-2"
                    >
                        <RadioGroupItem
                            id={`${id}-${String(option.value)}`}
                            value={String(option.value)}
                        />
                        <Label htmlFor={`${id}-${String(option.value)}`}>
                            {option.label}
                        </Label>
                    </div>
                ))}
            </UiRadioGroup>
            <FieldError error={error} />
        </div>
    );
};
